import type { FaireProductEntity } from "../../entity_types/product";

export const p_as23ayfqdc: FaireProductEntity = {
  token: "p_as23ayfqdc",
  type: "product",
  name: "Disco Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/00dc7f74e110bf6d3dc0a8ef70fade98660c16f6de54bf27862d7e166f3e50f1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/83c7322df8043d59b4ed7d98b7202dacfd7be9a72e817275159d28a4267cba37.jpeg",
    "https://cdn.faire.com/fastly/9530d58e0a0befa1c6358ae0c8a5c2801b835baf24ebf00208027bc272a2bf50.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/d77f4f8d8807b3927f796b3d9d759b88971d498d196e6e9ee853d293095555c5.jpeg",
    "https://cdn.faire.com/fastly/958bf09d5926ea1d3b5019d8165f298aefe311adbf220aaa6e1c3a7b23b6be0a.jpeg"
  ],
  priceDollars: 6.75,
  description: "These socks were born for funky beats, mirror balls, late nights, and maybe having a cute super tiny spoon on your keychain for whatever reason.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:59.563Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
